import React from 'react'
import { GoogleMap, GoogleMapProps } from '@react-google-maps/api'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineMapIcon from 'components/Luxkit/Icons/line/LineMapIcon'
import { EnsureGoogleMapsLoaded } from 'contexts/GoogleMapsContext'
import LoadingIndicator from '../Loading/LoadingIndicator'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import config from 'constants/config'
import PropertyMarkerV2 from './PropertyMarkerV2'

const STATIC_MAP_OPTIONS: GoogleMapProps['options'] = {
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  draggable: false,
  mapId: config.GOOGLE_MAP_ID,
  clickableIcons: false,
  draggableCursor: 'pointer',
}

const DYNAMIC_MAP_OPTIONS: GoogleMapProps['options'] = {
  disableDefaultUI: true,
  mapId: config.GOOGLE_MAP_ID,
  zoomControl: true,
  zoomControlOptions: {
    position: 7,
  },
}

const OpenModalButtonContainer = styled(Group)`
  padding: ${rem(12)};
`

interface Props {
  offer: App.Offer | App.BedbankOffer | App.HotelOffer
  openMapModal?: () => void
  zoom?: number,
  isStatic?: boolean
}

function MapV2({ offer, openMapModal, zoom, isStatic }: Props) {
  const { property } = offer
  if (!property) return null
  const { id, latitude, longitude } = property

  const handlePropertyMarkerClick = () => {
    if (isStatic && openMapModal) {
      openMapModal()
    } else if (!isStatic) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`)
    }
  }

  const handleMapClick = () => {
    if (isStatic && openMapModal) {
      openMapModal()
    }
  }

  return (
    <EnsureGoogleMapsLoaded loadingElement={<LoadingIndicator inline />}>
      <GoogleMap
          id={id}
          zoom={zoom || 13}
          mapContainerClassName="location-map"
          center={{
            lat: latitude,
            lng: longitude,
          }}
          options={isStatic ? STATIC_MAP_OPTIONS : DYNAMIC_MAP_OPTIONS}
          onClick={handleMapClick}
        >
        <PropertyMarkerV2 active={false} visited={false} soldOut={false} marker={{ offers: [offer], id, latitude, longitude }} onClick={handlePropertyMarkerClick}/>
        {openMapModal && (<OpenModalButtonContainer direction="horizontal" horizontalAlign="end" verticalAlign="end" fullHeight>
          <TextButton
              onClick={openMapModal}
              kind="secondary"
              variant="dark"
              startIcon={<LineMapIcon />}
              data-testid="map-view-button"
            >
            View map
          </TextButton>
        </OpenModalButtonContainer>)}
      </GoogleMap>
    </EnsureGoogleMapsLoaded>
  )
}

export default MapV2
